export const GOOGLE_CLIENT_ID = '763088249199-p7ce5bb5hrcmarml939f5pirhrroomc6.apps.googleusercontent.com';
export const FACEBOOK_APP_ID = '382238867303639';
export enum LoginStep {
  SelectMethod,
  SendPhoneCode,
  SendEmailCode,
  VerifyCode,
};
